<template>
	<div v-if="selectedTeam !== undefined && leagueId !== 342">
		<div class="flex pb-[9px] flex-col gap-y-2 justify-between xl:items-center xl:flex-row">
			<div class="flex justify-between w-full items-center">
        <span class="text-xl col-span-8 font-semibold px-2.5 xl:pl-0">Tabela H2H - {{ leagueName }}</span>
      </div>
			<div v-show="window.size.desktop && listOpen"
			     class="z-backdrop fixed left-0 top-0 w-full overflow-y-hidden h-full outline-none !bg-black/40">
			</div>
		</div>
		<div class="bg-zt-light/35 border border-zt-light rounded-zt">
      <div class="flex justify-between w-full items-center border-b border-zt-light bg-zt-light-full py-1 pr-3 pl-2 xl:!pl-4">
        <span class="text-xs px-2.5 xl:pl-0">TABELA H2H - {{ leagueName }}</span>
        <div class="flex gap-x-[6px]">
          <div class="my-auto w-[34px] !leading-[12px]">
            <span v-if="window.size.desktop"
                  class="w-[34px] uppercase text-right text-zt-more text-[10px] !leading-[12px] font-medium">
              Zmień widok
            </span>
          </div>
          <div @click="changeView()"
               class="px-2.5 py-1 flex max-h-[28px] items-center gap-x-2.5 rounded-zt border zt-hover cursor-pointer border-zt-light bg-[#3A4B64B2]">
            <div>
              <svg :class="view === 'normal' ? '' : 'opacity-40 max-h-[13px]'"
                   xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <rect x="0.425781" y="0.8125" width="19.375" height="19.375" rx="4.6875" stroke="white" stroke-width="0.625"/>
                <g>
                  <rect x="2.61328" y="3.625" width="15" height="2" rx="1" fill="white"/>
                  <rect x="2.61328" y="7.375" width="15" height="2" rx="1" fill="white"/>
                  <rect x="2.61328" y="11.125" width="15" height="2" rx="1" fill="white"/>
                  <rect x="2.61328" y="14.875" width="15" height="2" rx="1" fill="white"/>
                </g>
              </svg>
            </div>
            <div>
              <svg
                  :class="view === 'compact' ? '' : 'opacity-40 max-h-[13px]'"
                  xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <rect x="0.425781" y="0.3125" width="19.375" height="19.375" rx="4.6875" stroke="white" stroke-width="0.625"/>
                <g>
                  <rect x="7.27344" y="6.87109" width="5.98307" height="2" rx="1" fill="white"/>
                  <rect x="7.27344" y="3.53906" width="5.98307" height="2" rx="1" fill="white"/>
                  <rect x="7.27344" y="10.625" width="5.98307" height="2" rx="1" fill="white"/>
                  <rect x="7.27344" y="14.375" width="5.98307" height="2" rx="1" fill="white"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="px-2.5 border-b border-zt-light py-2.5 xl:mb-2.5" :class="{ 'mb-2.5' : season_phases.length > 1 && window.size.mobile }">
        <div v-click-outside="clickOutside" class="cursor-pointer w-full xl:relative" :class="{ 'z-modal' : listOpen }">
          <div>
            <div @click="handleListClick" ref="list"
                 class="w-full text-xs h-[28px] relative pl-[6px] pr-4 rounded-zt flex justify-center items-center border
                    border-zt-light">
              <Transition name="fade" mode="out-in">
                <div v-if="selectedTeam" class="font-medium flex items-center gap-x-[6px]">
                  <span class="inline-block aspect-square h-[18px]">
                    <TeamImg :team="selectedTeam"/>
                  </span>
                  {{ selectedTeam.shortname?.length > 0 ? selectedTeam.shortname : selectedTeam.name }}
                </div>
              </Transition>
              <svg :class="{ 'rotate-180' : listOpen }" class="transition absolute right-4" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.99875 0.083984L4.25 3.32815L7.50125 0.0839843L8.5 1.08273L4.25 5.33273L1.94762e-07 1.08273L0.99875 0.083984Z" fill="white"/>
              </svg>
            </div>
          </div>
          <TeamSelectList v-if="listOpen" @selected-team="onSelectedTeam" @close="closeSelect"
                          :teamsSelect="teamsSelect" :default-selected-team="selectedTeam" />
        </div>
      </div>
      <div v-if="season_phases.length > 1 && leagueId !== 253" class="pb-2.5 border-b border-zt-light rounded-t-zt xl:mb-2.5 flex text-xs px-2 gap-x-10">
        <div v-if="window.size.desktop" class="w-full text-center rounded-zt border border-zt-light opacity-75 flex items-center justify-center basis-1/2">
	        <p>{{ seasonsType === 'year' ? season : `${ season } / ${ +season + 1 }` }}</p>
        </div>
        <SeasonPhaseSelect :classes="`w-full !text-center rounded-zt border border-zt-light xl:basis-1/2`"
                           :options="season_phases" :default="selected_phase.string" :model="selected_phase" />
      </div>
			<div ref="statsFilter" class="static">
				<div class="bg-[#283344] pt-2.5 xl:border-b-0 xl:!shadow-none xl:!pt-0">
					<FootballStatsFilter analytic-type="h2h" :options="filteringOptions" :is-league-results="true"
                               :key="getKeyForFilteringOptions(filteringOptions)"
                               swiper-id="swiper2" @filtering-changed="(value) => { selectedFilters = value }"/>
				</div>
			</div>
			<div v-if="selectedTeam">
				<H2hMainTable v-for="[key, data] in Object.entries(tableData)"
					analytic-type="league-h2h-overview"
					:teams="data"
          :group="key"
          :view="view"
					:selectedFilters="selectedFilters"
					:teamId="+selectedTeam.team_id"
          :league-id="leagueId"/>
			</div>
			<Transition name="collapse">
				<div v-if="(selectedFilters[0] === 'cards' && selectedFilters[2] === 'result') || selectedFilters[0] === 'fouls' || selectedFilters[0] === 'offsides'"
             class="border-t border-zt-light w-full px-3 py-3.5 flex items-center gap-2">
					<span class="inline-block w-1 h-3.5 bg-[#2AEB26] rounded-zt"></span>
					<span class="text-zt-more text-xs">Kolor zielony oznacza niechlubne zwycięstwo</span>
				</div>
			</Transition>
			<Transition name="collapse">
				<div v-if="selectedFilters[0]==='odds' && selectedFilters[1] === '1x2'"
             class="border-t border-zt-light w-full px-3 py-3.5 flex items-center gap-2">
					<span class="text-zt-more text-xs">Kurs na zwycięstwo zaznaczonej drużyny - rozliczenie trzydrogowe</span>
				</div>
			</Transition>
			<Transition name="collapse">
				<div v-if="selectedFilters[0]==='odds' && selectedFilters[1] === 'winLose'"
             class="border-t border-zt-light w-full px-3 py-3.5 flex items-center gap-2">
					<span class="text-zt-more text-xs">Kurs na zwycięstwo zaznaczonej drużyny - rozliczenie: trafony lub nietrafiony</span>
				</div>
			</Transition>
			<Transition name="collapse">
				<div v-if="selectedFilters[0]==='cleansheet'" class="border-t border-zt-light w-full px-3 py-3.5">
					<div class="flex items-center gap-2 mb-2">
						<span class="inline-block w-1 h-3.5 bg-[#2AEB26] rounded-zt"></span>
						<span class="text-zt-more text-xs">Czyste konto</span>
					</div>
					<div class="flex items-center gap-2">
						<span class="inline-block w-1 h-3.5 bg-[#CE2121] rounded-zt"></span>
						<span class="text-zt-more text-xs">Brak czystego konta</span>
					</div>
				</div>
			</Transition>
		</div>
	</div>
</template>

<script>
import H2hTable from './H2hTable.vue';
import FootballStatsFilter from '../../FootballStatsFilter.vue';
import H2hMainTable from './H2hMainTable.vue';
import TeamImg from '../blocks/TeamImg.vue';
import {
  deepCopy,
  footballFilteringOptions,
  resetOptionsFor
} from '../../../../assets/js/football-filtering-options.js';
import utils_mixin from '../../../mixins/utils_mixin';
import FormSelect from '../../FormSelect.vue';
import { phaseDisplayInSelectPriority, phasePriority, leagueNameAlternatives } from '../../../../assets/js/utils';
import SeasonPhaseSelect from '../../SeasonPhaseSelect.vue';
import TeamSelectList from '../blocks/TeamSelectList.vue';
import sticky_filtering_mixin from '../../../mixins/sticky_filtering_mixin';

export default {
	name: 'H2hOverviewTable',
	inject: ['WP'],
	mixins: [utils_mixin],
	components: {TeamSelectList, SeasonPhaseSelect, FormSelect, TeamImg, H2hMainTable, FootballStatsFilter, H2hTable},
	props: ['season', 'seasonsType'],
	data() {
		return {
      teams_phases: [],
			selectedTeam: null,
			selectedFilters: ['table', 'all'],
      season_phases: [],
      selected_phase: { string: '' },
			listOpen: false,
			clickOutside: {
				handler: () => {
					this.listOpen = false;
					if (window.size.desktop) {
						this.unblockScrolling();
					}
				},
				events: ['touchend', 'mouseup'],
			},
      view: 'normal',
      clickedView: false,
		}
	},
  computed: {
    teams() {
      if (this.leagueId === 253) {
        if (Object.hasOwn(this.teams_phases, 'Western_Conference') && Object.hasOwn(this.teams_phases, 'Eastern_Conference')) {
          return [...this.teams_phases.Western_Conference[0], ...this.teams_phases.Eastern_Conference[0]]
        }
      } else if (this.leagueId !== 253) {
        if (Object.hasOwn(this.teams_phases, this.selected_phase.string)) {
          return this.teams_phases[this.selected_phase.string][0];
        }
      }
      return [];
    },
    filteringOptions() {
      const filteredOptions = deepCopy(footballFilteringOptions);
      resetOptionsFor(filteredOptions, 'Table');
      const baseOptions = [
        filteredOptions.Table,
        footballFilteringOptions.Corners,
        footballFilteringOptions.Cards,
        footballFilteringOptions.BTTS,
        footballFilteringOptions.OverUnder,
        footballFilteringOptions.Halves,
        footballFilteringOptions.CleanSheets,
      ];
      if(this.teams?.some((team) => {
        let corners = 0;

        if (team.home_match.length == 0 || team.visitor_match.length == 0 ||
            (team.home_match.every((match) => match.status !== 'FT') &&
             team.visitor_match.every((match) => match.status !== 'FT'))
        ) {
          corners = 1;
        }
        team.home_match.forEach((match) => {
          corners += Number(match.localteam_corners) + Number(match.visitorteam_corners);
        });
        team.visitor_match.forEach((match) => {
          corners += Number(match.localteam_corners) + Number(match.visitorteam_corners);
        });
        return corners === 0;
      })) {
        let index = baseOptions.findIndex(el => {
          return el.name === 'Rożne';
        })
        if (index !== -1) {
          baseOptions.splice(index, 1);
        }
      }

      let leagueSpecificOptions = [];
      const teamsHasOdds = this.teams.some((team) => {
        return team.home_match.some((match) => match.odds !== null) ||
            team.visitor_match.some((match) => match.odds !== null);
      });

      if (teamsHasOdds) {
        leagueSpecificOptions.push(footballFilteringOptions.Odds);
      }

      const leagueSpecificLastOptions = [78, 106, 140, 61, 39, 135, 88].includes(this.leagueId)
          ? [
            footballFilteringOptions.BallPossesion,
            footballFilteringOptions.Shots,
            footballFilteringOptions.Offsides,
            footballFilteringOptions.Fouls,
            footballFilteringOptions.Passes
          ] : [];

      const [firstOption, ...options] = baseOptions;
      if (leagueSpecificLastOptions.length === 0) {
        return [firstOption, ...leagueSpecificOptions, ...options]
      }
      return [firstOption, ...leagueSpecificOptions, ...options, ...leagueSpecificLastOptions];
    },
    tableData() {
      if (this.selectedTeam !== undefined && this.selectedTeam !== null) {
        let data = [];
        let upcomingMatches = [];
        this.teams.forEach( team => {
          data.push({
            id: +team.id,
            name: team.name,
            shortname: team.shortname,
            team_query_name: team.team_query_name,
            country_query_name: team.country_query_name,
            league_query_name: team.league_query_name,
            position: +team.position,
            points: +team.points,
            homeMatch: team.home_match,
            visitorMatch: team.visitor_match,
            group: team.group_name
          });
          team.home_match.forEach((match) => {
            if (match.status != 'FT') {
              upcomingMatches.push(match);
            }
          });
          team.visitor_match.forEach((match) => {
            if (match.status != 'FT') {
              upcomingMatches.push(match);
            }
          });
        });
        if (upcomingMatches.length) {
          upcomingMatches.reduce((previous, current) => {
            return DateTime.fromSQL(previous.date) < DateTime.fromSQL(current.date) ? previous : current;
          }).isNextMatch = true;
        }

        if (this.leagueId !== 253) {
          return { 'group' : data.sort((a,b) => {
              return a.position - b.position;
            })};
        }

        let groupedTeams = data.reduce((accumulator, team) => {
          if (!accumulator[team.group]) {
            accumulator[team.group] = [];
          }
          accumulator[team.group].push(team);
          return accumulator;
        }, {});

        return Object.fromEntries(Object.entries(groupedTeams).sort((a, b) => {
          return b[1].length - a[1].length;
        }));
      }
    },
    leagueId() {
      return +this.$attrs.leagueId;
    },
    leagueName() {
      return this.$attrs.leagueName;
    },
    teamsSelect() {
      let teams = JSON.parse(this.$attrs.teams);
			if ((this.selected_phase.string === 'Regular_Season' && this.leagueName === 'MLS') || this.leagueId === 253) {
				return teams.sort((a, b) => {
					return a.name.localeCompare(b.name);
				});
			}
      teams = teams.filter(team => {
        return team.season_phases.some(phase => {
          if (this.selected_phase.string !== '') {
            return phase.phase?.replaceAll(' ', '_').includes(this.selected_phase.string)
              || phase.phase === this.leagueName
              || (Object.hasOwn(leagueNameAlternatives, this.leagueName)
                && leagueNameAlternatives[this.leagueName].includes(phase.phase));
          } else {
            return true;
          }
        });
      });
      return teams.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  },
  watch: {
    selectedTeam() {
      this.loadH2hTeamData();
    }
  },
	mounted() {
    let championshipTeam = this.teamsSelect.find(team =>
        team.season_phases.some(phase =>
            phase.phase?.includes('Championship Round') && Number(phase.position) === 1 && Number(phase.played) > 0
        )
    );
    if (!championshipTeam) {
      let relegationTeam = this.teamsSelect.find(team =>
          team.season_phases.some(phase =>
              phase.phase?.includes('Relegation Round') && Number(phase.position) === 1 && Number(phase.played) > 0
          )
      );
      if (relegationTeam) {
        this.selectedTeam = relegationTeam;
      } else {
        let regularSeasonTeam = this.teamsSelect.find(team =>
            team.season_phases.some(phase =>
                phase.phase?.includes('Regular Season') && Number(phase.position) === 1
            )
        );
        let firstTeam = this.teamsSelect.find(team =>
            team.season_phases.some(phase =>
                Number(phase.position) === 1
            )
        );
        this.selectedTeam = regularSeasonTeam || firstTeam;
      }
    } else {
      this.selectedTeam = championshipTeam;
    }
    this.removePlaceholder(this.$attrs.component);
	},
	methods: {
    changeView() {
      this.view = this.view === 'normal' ? 'compact' : 'normal';
      if (this.clickedView) {
        return;
      }
      this.countClicks('Ściśnięta KOLOROWA - filtr A-B', 'football');
      this.clickedView = true;
    },
    closeSelect() {
      this.unblockScrolling();
      this.listOpen = false;
    },
		onSelectedTeam(team) {
			this.unblockScrolling();
      if (this.selectedTeam === team) {
        return;
      }
			this.selectedTeam = team;
			this.listOpen = false;
		},
		handleListClick() {
			this.listOpen = !this.listOpen;
			if (!this.listOpen) {
				this.unblockScrolling();
			} else {
				if (window.size.desktop) {
					let extraOff = WP.user.adminBar ? -32 : 0;
					const y = this.$refs.list.getBoundingClientRect().top + window.pageYOffset + extraOff - 150;
					this.blockScrolling();
					window.scrollTo({top: y, behavior: 'smooth'});
				} else {
					this.blockScrolling();
				}
			}
			this.countClicks('Kolorowa ➝ kliki w wybór drużyny (w lidze przegląd i tabela)');
		},
		loadH2hTeamData() {
      if (this.selectedTeam !== undefined && this.selectedTeam !== null) {
        axios
          .post(this.WP.ajaxUrl, {
            endpoint: 'api_get_h2h_stats',
            team_id: this.selectedTeam.team_id,
            league_id: this.leagueId,
          })
          .then(response => {
            this.teams_phases = response.data.data;
            this.season_phases = Object.keys(this.teams_phases);
            this.season_phases = phaseDisplayInSelectPriority.filter(phase => this.season_phases.indexOf(phase) > -1);
            for (let phase of phasePriority) {
              if (this.teams_phases[phase] && this.teams_phases[phase].some(group => group.some(team => {
                  return team.home_match.some(match => match.status === 'FT') ||
                      team.visitor_match.some(match => match.status === 'FT');
                }
              ))) {
                this.selected_phase.string = phase;
                break;
              }
            }
            if (!this.selected_phase.string) {
              this.selected_phase.string = 'Regular_Season';
            }
          });
      }
		},
    getKeyForFilteringOptions(options) {
      return options.reduce((acc, cur) => acc += cur.name, '');
    },
	},
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  z-index: 10;
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  z-index: 10;
  opacity: 0;
}

.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease-out;
	overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
	padding-top: 0;
	padding-bottom: 0;
	max-height: 0;
	opacity: 0;
}

.collapse-enter-to,
.collapse-leave-from {
	max-height: 70px;
}
</style>